// @flow
import OfflineIndicator from './offline-indicator';

export default OfflineIndicator;
